import * as React from "react";
import { useEffect, useState } from "react";
import { styled } from "@mui/system";
import TablePagination from "@mui/material/TablePagination";
import axios from "axios";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const url = process.env.REACT_APP_URL;

const blue = {
  200: "#A5D8FF",
  400: "#3399FF",
};

const grey = {
  50: "#F3F6F9",
  100: "#E7EBF0",
  200: "#E0E3E7",
  300: "#CDD2D7",
  400: "#B2BAC2",
  500: "#A0AAB4",
  600: "#6F7E8C",
  700: "#3E5060",
  800: "#2D3843",
  900: "#1A2027",
};

const Root = styled("div")(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    text-align: left;
    padding: 6px;
  }

  th {
    background-color: ${theme.palette.mode === "dark" ? grey[900] : grey[100]};
  }
`
);

const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  .MuiTablePagination-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .MuiTablePagination-select {
    border: 1px solid ${
      theme.palette.mode === "dark" ? grey[800] : grey[200]
    };
    border-radius: 5px;
    padding: 2px;
  }

  .MuiTablePagination-actions button {
    border-radius: 4px;
  }
`
);

export default function UnstyledTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [arr, setArr] = React.useState([]);
  const [duration, setDuration] = React.useState(20);

  const [startOffset, setStartOffset] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [endOffset, setEndOffset] = useState(
    new Date().toISOString().split("T")[0]
  );

  const handleChange = (event) => {
    setDuration(event.target.value);
  };

  useEffect(() => {
    console.log("duration 1", duration);

    if (duration === 10) {
      const d = new Date();
      const t = d.toISOString().split("T")[0];

      axios
        .get(`${url}/api/v1/call/logs?startOffset=${t}&endOffset=${t}&sites=`)
        .then((response) => {
          const sortedRows = [...(response.data.data || [])].sort((a, b) => {
            const aTime = new Date(String(a.ts || 0)).getTime();
            const bTime = new Date(String(b.ts || 0)).getTime();
            return bTime - aTime;
          });
          setArr(sortedRows);
        });

      setStartOffset(t);
      setEndOffset(t);
    } else if (duration === 20) {
      const d = new Date();
      const h = d.toISOString().split("T")[0];

      const sevenDaysBefore = d.setDate(d.getDate() - 7);
      const g = new Date(sevenDaysBefore);

      const t = g.toISOString().split("T")[0];

      setStartOffset(h);
      setEndOffset(t);

      axios
        .get(`${url}/api/v1/call/logs?startOffset=${t}&endOffset=${h}&sites=`)
        .then((response) => {
          const sortedRows = [...(response.data.data || [])].sort((a, b) => {
            const aTime = new Date(String(a.ts || 0)).getTime();
            const bTime = new Date(String(b.ts || 0)).getTime();
            return bTime - aTime;
          });
          setArr(sortedRows);
        });
    } else if (duration === 30) {
      const d = new Date();
      const t = d.toISOString().split("T")[0];

      axios
        .get(
          `${url}/api/v1/call/logs?startOffset=2022-08-01&endOffset=${t}&sites=`
        )
        .then((response) => {
          const sortedRows = [...(response.data.data || [])].sort((a, b) => {
            const aTime = new Date(String(a.ts || 0)).getTime();
            const bTime = new Date(String(b.ts || 0)).getTime();
            return bTime - aTime;
          });
          setArr(sortedRows);
        });
    }
  }, [duration]);

  const rows = arr;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="row">
        <Box sx={{ maxWidth: 300 }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select</InputLabel>

            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={duration}
              label="Select"
              onChange={handleChange}
            >
              <MenuItem value={10}>Today</MenuItem>
              <MenuItem value={20}>Last 7 days</MenuItem>
              <MenuItem value={30}>All</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </div>

      <div className="row" style={{ width: "auto", overflow: "scroll" }}>
        <Root sx={{ maxWidth: "100%" }}>
          <table aria-label="custom pagination table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Site Code</th>
                <th>Bus Stop</th>
                <th>Road</th>
                <th>Towards</th>
                <th>Time Of Call</th>
                <th>Duration(s)</th>
                <th>Mode</th>
              </tr>
            </thead>

            <tbody>
              {(rowsPerPage > 0
                ? rows.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : rows
              ).map((row, index) => {
                const date1 = new Date(row.ts.slice(0, 19) + " UTC");

                const istOffset =
                  5 * 60 * 60 * 1000 + 30 * 60 * 1000;

                const dateIST = new Date(date1.getTime() - istOffset);

                const ws = dateIST.toString();
                const ds = ws.slice(0, 24);

                return (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td style={{ width: 60 }} align="center">
                      {row.site_code}
                    </td>

                    <td>{row.bus_stop_name}</td>

                    <td style={{ width: 120 }} align="center">
                      {row.road_name}
                    </td>

                    <td style={{ width: 120 }} align="center">
                      {row.towards}
                    </td>

                    <td style={{ width: 120 }} align="center">
                      {ds}
                    </td>

                    <td style={{ width: 40 }} align="center">
                      {(row.call_time < 60 &&
                        row.call_time + "sec") ||
                        (row.call_time > 60 &&
                          Math.floor(row.call_time / 60) +
                            "min " +
                            (row.call_time % 60) +
                            "sec")}
                    </td>

                    <td style={{ width: 120 }} align="center">
                      {row.call_mode}
                    </td>
                  </tr>
                );
              })}

              {emptyRows > 0 && (
                <tr style={{ height: 41 * emptyRows }}>
                  <td colSpan={8} />
                </tr>
              )}
            </tbody>

            <tfoot>
              <tr>
                <td colSpan={8}>
                  <CustomTablePagination
                    rowsPerPageOptions={[
                      25,
                      50,
                      100,
                      { label: "All", value: -1 },
                    ]}
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </Root>
      </div>
    </>
  );
}
